export default __webpack_public_path__ + "static/media/vChurchill.1cc2553f.png";